// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"d6479f4d","186":"c87d9f13","200":"5616f5d6","471":"76251603","596":"2a702716"}[chunkId] + ".chunk.js";
};